module.exports = __webpack_public_path__ + "static/media/gif certo.429adaa0.gif";